(function setupMobileAppUI() {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has('mapp')) {
        const headerGroup = document.querySelectorAll('.shopify-section-group-header-group');
        const footerGroup = document.querySelectorAll('.shopify-section-group-footer-group');
        headerGroup.forEach((header) => (header.style.display = 'none'));
        footerGroup.forEach((footer) => (footer.style.display = 'none'));
    }
})();
